import { useState } from 'react';
import { useQuery, useLazyQuery } from '@apollo/client';
import { GET_WALLET, INITIATE_CREDIT_RECHARGE, GET_COMMUNICATION_CENTER_TOKEN } from '../graphql/queries';

const RECHARGE_PAGE_URL = process.env.REACT_APP_RECHARGE_PAGE_URL || 'https://payment.rietail.com/authenticate/';
const COMMUNICATION_PAGE_URL = process.env.REACT_APP_COMMUNICATION_PAGE_URL || 'https://d2lj4x8g5zy2ir.cloudfront.net/authenticate';

const navItems = [
  {
    key: 'dashboard',
    label: 'Dashboard',
    icon: (
      <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
      </svg>
    ),
  },
  {
    key: 'staff',
    label: 'Staff',
    icon: (
      <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
  },
  {
    key: 'products',
    label: 'Products',
    icon: (
      <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
      </svg>
    ),
  },
  // {
  //   key: 'orders',
  //   label: 'Orders',
  //   icon: (
  //     <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
  //       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
  //     </svg>
  //   ),
  // },
  {
    key: 'settings',
    label: 'Settings',
    icon: (
      <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
  },
  {
    key: 'integrations',
    label: 'Integrations',
    icon: (
      <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
      </svg>
    ),
  },
  // {
  //   key: 'communication',
  //   label: 'Communication',
  //   external: true,
  //   icon: (
  //     <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
  //       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
  //     </svg>
  //   ),
  // },
];

export default function Sidebar({ storeName, activePage, onNavigate }) {
  const initial = storeName?.charAt(0)?.toUpperCase() || 'L';
  const [recharging, setRecharging] = useState(false);

  const { data: walletData } = useQuery(GET_WALLET);
  const credits = walletData?.getWallet?.wallet?.availableCredits ?? 0;

  const [fetchCommunicationToken] = useLazyQuery(GET_COMMUNICATION_CENTER_TOKEN, {
    fetchPolicy: 'network-only',
    onCompleted: (res) => {
      const token = res?.getCommunicationCenterToken?.token;
      if (token) window.open(`${COMMUNICATION_PAGE_URL}/${token}`, '_blank');
    },
  });

  const [initiateCreditRecharge] = useLazyQuery(INITIATE_CREDIT_RECHARGE, {
    fetchPolicy: 'network-only',
    onCompleted: (res) => {
      setRecharging(false);
      if (!res?.initiateCreditRecharge?.error && res?.initiateCreditRecharge?.token) {
        const token = res.initiateCreditRecharge.token;
        const redirectUrl = `${RECHARGE_PAGE_URL}${token}?${window.location.origin}/dashboard`;
        window.location.href = redirectUrl;
      }
    },
    onError: () => setRecharging(false),
  });

  const handleAddCredits = () => {
    setRecharging(true);
    initiateCreditRecharge();
  };

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <div className="sidebar-brand">
          <div className="sidebar-avatar">{initial}</div>
          <div className="sidebar-brand-info">
            <div className="sidebar-label">Store</div>
            <div className="sidebar-store-name">{storeName}</div>
          </div>
        </div>
      </div>

      <nav className="sidebar-nav">
        <div className="sidebar-section-label">Menu</div>
        {navItems.map((item) => (
          <button
            key={item.key}
            onClick={() => item.key === 'communication' ? fetchCommunicationToken() : onNavigate(item.key)}
            className={`nav-item ${(activePage === item.key || activePage.startsWith(item.key + '/')) ? 'nav-item--active' : 'nav-item--inactive'}`}
          >
            {item.icon}
            {item.label}
            {item.external && (
              <svg className="nav-item-external" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
              </svg>
            )}
          </button>
        ))}
      </nav>

      <div className="wallet-widget">
        <div className="wallet-widget-label">
          <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
          </svg>
          Credits
          <button
            className="wallet-history-btn"
            onClick={() => onNavigate('wallet-history')}
            title="View usage history"
          >
            <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </button>
        </div>
        <div className="wallet-widget-balance">{credits}</div>
        <button className="wallet-widget-btn" onClick={handleAddCredits} disabled={recharging}>
          <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
          {recharging ? 'Redirecting...' : 'Add Credits'}
        </button>
      </div>

      <div className="sidebar-footer">
        <div className="sidebar-footer-inner">
          <span className="sidebar-footer-dot" />
          <span className="sidebar-footer-text">Listing App &bull; v1.0</span>
        </div>
      </div>
    </aside>
  );
}
